
export default {
  props: {
    team: {
      type: Object,
      required: true,
    },
    side: {
      type: String,
      default: `left`,
    },
    mobileTooltipOpen: {
      type: Boolean,
      default: false,
    },
    formation: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      activePlayer: {},
    };
  },
  inject: [`lastUpdated`],
  computed: {
    playersOnPitch () {
      return this.team.lineups.filter(player => player.formationNumber !== `0`);
    },
    lineup () {
      if (this.playersOnPitch.length && this.formation) {
        const formationArray = this.getFormationArray();
        const formationPositions = this.getFormationPositions();

        const lineup = {
          GK: [
            {
              ...this.playersOnPitch.find(player => parseInt(player.formationNumber) === 1),
              currentPosition: `GK`,
            },
          ],
        };

        for (const [i, line] of formationArray.entries()) {
          const numPlayers = parseInt(line);
          const position = formationPositions[i]; // e.g. `DF`
          const formationNumbers = this.getFormationNumbers(position, numPlayers);
          const positionPlayers = [];
          for (const [index, num] of formationNumbers.entries()) {
            const player = [...this.playersOnPitch].find(player => parseInt(player.formationNumber) === num);
            const playerPosition = this.linePositions[position][numPlayers][index];
            positionPlayers.push({ ...player, currentPosition: playerPosition });
          }
          lineup[position] = positionPlayers;
        }

        return lineup;
      }
      return null;
    },
  },
  methods: {
    getFormationNumbers (position, numPlayers) {
      if (this.formationMap[position][this.formation]) {
        return this.formationMap[position][this.formation];
      }
      return this.formationMap[position][numPlayers.toString()];
    },
    getFormationArray () {
      const formationLabel = this.formationLabels[this.formation] || this.formation;
      return formationLabel
        .replace(/d/g, ``)
        .replace(/0/g, ``)
        .split(``);
    },
    getFormationPositions () {
      const formationLabel = this.formationLabels[this.formation] || this.formation;
      const formationArray = this.getFormationArray();
      return this.formationLayouts[formationLabel]
        ? this.formationLayouts[formationLabel]
        : formationArray.length === 4
          ? [`DF`, `MF`, `AMF`, `ST`]
          : [`DF`, `MF`, `ST`];
    },
    getPlayersByPosition (position, players = []) {
      return this.team.squad.filter(player => player.position === position && !players.includes(player));
    },
    openMobileTooltip (player) {
      this.$parent.mobileTooltips[this.side] = true;
      if (this.side === `left`) {
        this.$parent.mobileTooltips.right = false;
      } else {
        this.$parent.mobileTooltips.left = false;
      }
      this.activePlayer = player;
    },
    closeMobileTooltip () {
      this.$parent.mobileTooltips.left = false;
      this.$parent.mobileTooltips.right = false;
    },
  },
};
